module.exports = __webpack_public_path__ + "static/img/2Business-Analytics.6967e722.gif";